"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _EntelPlanCard = _interopRequireDefault(require("./EntelPlanCard"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../../../services");
var _useRecommendationPlans = require("../../../../hooks/recommendation/useRecommendationPlans");
var _constants = require("../../../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const BorderWrapper = _styledComponents.default.div`
  border: 1px solid #bebebe;
  border-radius: 12px;
  padding: 20px 24px 20px 24px;
`;
const AlternativePlanRecommendation = () => {
  const recommendedPlan = (0, _useRecommendationPlans.getPlan)(_constants.RECOMMENDATION_TIER.RECOMMENDED);
  return /*#__PURE__*/_react.default.createElement(BorderWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    dataAttributes: {
      'data-testid': 'alternative-plan-summary-title'
    },
    text: _services.Services.locale.localeString('Recommendation.Summary'),
    size: 1,
    weight: 2
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, null), /*#__PURE__*/_react.default.createElement(_EntelPlanCard.default, {
    plan: recommendedPlan,
    isAdditionalPlan: true
  }));
};
var _default = AlternativePlanRecommendation;
exports.default = _default;